import { updateUserPhoneNumberSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { useAuth } from '../utils/AuthContext.js';
import { getInfoForUser } from './common/util.js';
import { InfoIsFromEmployerMessage } from './common/CommonComponents.js';

const PhoneNumberFields = () => (
  <>
    <FormInput name="phoneNumber" type="text" />
    <FormInput name="textMessagingApproved" type="checkbox" />
  </>
);

const phoneNumberPreValidation = ({ getValues, setValue }) => {
  if (getValues('phoneNumber') === '') {
    setValue('phoneNumber', null);
  }
};

const PhoneNumberForm = ({ onFinish, submitLabel }) => {
  const { user, userEmployments, api } = useAuth();
  const { phoneNumber, textMessagingApproved, infoComesFromEmployer } = getInfoForUser(
    user,
    userEmployments,
    (v) => v.phoneNumber,
  );

  return (
    <ValidatedForm
      key="userPhoneNumber"
      schema={updateUserPhoneNumberSchema}
      initialValues={{ phoneNumber, textMessagingApproved: textMessagingApproved ?? true }}
      preValidation={phoneNumberPreValidation}
      handleSubmit={api.updateUserPhoneNumber}
      onFinish={onFinish}
    >
      {infoComesFromEmployer && <InfoIsFromEmployerMessage />}
      <PhoneNumberFields />
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  );
};

export { PhoneNumberFields, phoneNumberPreValidation };
export default PhoneNumberForm;
